import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteFacturationMode } from '../../api/TICKET/ticketMeta';
import { toast } from 'react-toastify';

export const useDeleteFacturationMode = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteFacturationMode,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['facturationModes'] });
            toast.success('Méthode de facturation supprimée avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la suppression de la méthode de facturation');
        },
    });
};
